// Local replacement for moment-duration-format's
// `format("w [weeks], d [days], h [hours], m [minutes]", { trim: "both" })`.
export const formatDurationMs = (durationMs: number): string => {
	const totalMinutes = Math.max(0, Math.round(durationMs / 60000));

	const weeks = Math.floor(totalMinutes / (7 * 24 * 60));
	const days = Math.floor((totalMinutes % (7 * 24 * 60)) / (24 * 60));
	const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
	const minutes = totalMinutes % 60;

	const parts = [
		{ value: weeks, label: "weeks" },
		{ value: days, label: "days" },
		{ value: hours, label: "hours" },
		{ value: minutes, label: "minutes" },
	];

	let first = 0;
	while (first < parts.length - 1 && parts[first].value === 0) first++;
	let last = parts.length - 1;
	while (last > first && parts[last].value === 0) last--;

	return parts
		.slice(first, last + 1)
		.map((p) => `${p.value} ${p.label}`)
		.join(", ");
};
